// removed by extract-text-webpack-plugin
module.exports = {"root":"_2BjtZAk4Ukyk9_9F2V5Wli","logo":"_3Q8TTty8nnAqdfnfOlEfb3","panel":"_1S8VPNF88RTmG0OK0u8AFE","left":"_2JllDTkKhQ-_VpxKH-Xuby","right":"_2xLuSHX8G1NoFb2qU6DUew","inner":"_1y7owdoc7SmJH14K-o6xeq","cta":"_2UdS8rq6Ef2-7DZpj5jrZz","text":"_1duICf8BfFY5QECl9sp6K","button":"_1DEC5TCaeousaP40bBSxT-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/layout.scss
// module id = 1541
// module chunks = 0